import httpNodeClient from '@shared/api/httpNodeClient';

interface RequestCustomTokenPayload {
  email: string;
  device: string;
}

interface RequestCustomToken {
  idToken: string;
  refreshToken: string;
  expiresIn: string;
}

export interface RequestCustomTokenResponse {
  token: RequestCustomToken;
  expiresAt: string;
}

export const requestCustomToken = (payload: RequestCustomTokenPayload): Promise<RequestCustomTokenResponse> => {
  return httpNodeClient.post<RequestCustomTokenResponse>('/auth/custom-login', payload).then((res) => res.data);
};
